import { createElement, ReactNode } from 'react';
import { useStyles } from '@team-griffin/stylr';
import { content } from '@ux/type-size';
import { useTheme, Colorway } from '@uds/theme-utils';
import { getBodyColor } from 'presentation/utils/colorway';

interface OuterProps {
  colorway: Colorway;
  children?: ReactNode;
  [key: string]: any;
}

const useStylesheet = ({ colorway }: { colorway: Colorway }) => {
  const { theme } = useTheme();
  const { typography } = theme;

  return useStyles({
    default: {
      root: {
        color: getBodyColor(theme, colorway),
        ...content(),
        fontFamily: typography.content,
      },
    },
  });
};

const PureListItem = ({ colorway, children, ...props }: OuterProps) => {
  const { styles } = useStylesheet({ colorway });
  const itemProps = props['data-sourcepos'] ?? {};

  return createElement(
    'li',
    {
      ...itemProps,
      style: styles.root,
    },
    children,
  );
};

PureListItem.displayName = 'LegalDocumentListItem';

export default PureListItem;
